(function () {
var $9d69d6fe3d226587$export$3291343375ee8b92 = /** @class */ function() {
    function EventListener(eventTarget, eventName, eventOptions) {
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    EventListener.prototype.connect = function() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
    };
    EventListener.prototype.disconnect = function() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
    };
    // Binding observer delegate
    /** @hidden */ EventListener.prototype.bindingConnected = function(binding) {
        this.unorderedBindings.add(binding);
    };
    /** @hidden */ EventListener.prototype.bindingDisconnected = function(binding) {
        this.unorderedBindings.delete(binding);
    };
    EventListener.prototype.handleEvent = function(event) {
        var extendedEvent = $9d69d6fe3d226587$var$extendEvent(event);
        for(var _i = 0, _a = this.bindings; _i < _a.length; _i++){
            var binding = _a[_i];
            if (extendedEvent.immediatePropagationStopped) break;
            else binding.handleEvent(extendedEvent);
        }
    };
    Object.defineProperty(EventListener.prototype, "bindings", {
        get: function() {
            return Array.from(this.unorderedBindings).sort(function(left, right) {
                var leftIndex = left.index, rightIndex = right.index;
                return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
            });
        },
        enumerable: false,
        configurable: true
    });
    return EventListener;
}();
function $9d69d6fe3d226587$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        var stopImmediatePropagation_1 = event.stopImmediatePropagation;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation: function() {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation_1.call(this);
            }
        });
    }
}


var $a32b9e3914eee5c7$export$ab054a1ef92eeb01 = /** @class */ function() {
    function Dispatcher(application) {
        this.application = application;
        this.eventListenerMaps = new Map;
        this.started = false;
    }
    Dispatcher.prototype.start = function() {
        if (!this.started) {
            this.started = true;
            this.eventListeners.forEach(function(eventListener) {
                return eventListener.connect();
            });
        }
    };
    Dispatcher.prototype.stop = function() {
        if (this.started) {
            this.started = false;
            this.eventListeners.forEach(function(eventListener) {
                return eventListener.disconnect();
            });
        }
    };
    Object.defineProperty(Dispatcher.prototype, "eventListeners", {
        get: function() {
            return Array.from(this.eventListenerMaps.values()).reduce(function(listeners, map) {
                return listeners.concat(Array.from(map.values()));
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    // Binding observer delegate
    /** @hidden */ Dispatcher.prototype.bindingConnected = function(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
    };
    /** @hidden */ Dispatcher.prototype.bindingDisconnected = function(binding) {
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
    };
    // Error handling
    Dispatcher.prototype.handleError = function(error, message, detail) {
        if (detail === void 0) detail = {};
        this.application.handleError(error, "Error " + message, detail);
    };
    Dispatcher.prototype.fetchEventListenerForBinding = function(binding) {
        var eventTarget = binding.eventTarget, eventName = binding.eventName, eventOptions = binding.eventOptions;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
    };
    Dispatcher.prototype.fetchEventListener = function(eventTarget, eventName, eventOptions) {
        var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        var cacheKey = this.cacheKey(eventName, eventOptions);
        var eventListener = eventListenerMap.get(cacheKey);
        if (!eventListener) {
            eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
            eventListenerMap.set(cacheKey, eventListener);
        }
        return eventListener;
    };
    Dispatcher.prototype.createEventListener = function(eventTarget, eventName, eventOptions) {
        var eventListener = new (0, $9d69d6fe3d226587$export$3291343375ee8b92)(eventTarget, eventName, eventOptions);
        if (this.started) eventListener.connect();
        return eventListener;
    };
    Dispatcher.prototype.fetchEventListenerMapForEventTarget = function(eventTarget) {
        var eventListenerMap = this.eventListenerMaps.get(eventTarget);
        if (!eventListenerMap) {
            eventListenerMap = new Map;
            this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }
        return eventListenerMap;
    };
    Dispatcher.prototype.cacheKey = function(eventName, eventOptions) {
        var parts = [
            eventName
        ];
        Object.keys(eventOptions).sort().forEach(function(key) {
            parts.push("" + (eventOptions[key] ? "" : "!") + key);
        });
        return parts.join(":");
    };
    return Dispatcher;
}();


// capture nos.:            12   23 4               43   1 5   56 7      768 9  98
var $5697ba647c0b1663$var$descriptorPattern = /^((.+?)(@(window|document))?->)?(.+?)(#([^:]+?))(:(.+))?$/;
function $5697ba647c0b1663$export$bc31880a8cab46de(descriptorString) {
    var source = descriptorString.trim();
    var matches = source.match($5697ba647c0b1663$var$descriptorPattern) || [];
    return {
        eventTarget: $5697ba647c0b1663$var$parseEventTarget(matches[4]),
        eventName: matches[2],
        eventOptions: matches[9] ? $5697ba647c0b1663$var$parseEventOptions(matches[9]) : {},
        identifier: matches[5],
        methodName: matches[7]
    };
}
function $5697ba647c0b1663$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $5697ba647c0b1663$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce(function(options, token) {
        var _a;
        return Object.assign(options, (_a = {}, _a[token.replace(/^!/, "")] = !/^!/.test(token), _a));
    }, {});
}
function $5697ba647c0b1663$export$51f7ca27b47bde29(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}


var $8f5752b1045c2551$export$e19cd5f9376f8cee = /** @class */ function() {
    function Action(element, index, descriptor) {
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $8f5752b1045c2551$export$1434b6878b59a330(element) || $8f5752b1045c2551$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $8f5752b1045c2551$var$error("missing identifier");
        this.methodName = descriptor.methodName || $8f5752b1045c2551$var$error("missing method name");
    }
    Action.forToken = function(token) {
        return new this(token.element, token.index, (0, $5697ba647c0b1663$export$bc31880a8cab46de)(token.content));
    };
    Action.prototype.toString = function() {
        var eventNameSuffix = this.eventTargetName ? "@" + this.eventTargetName : "";
        return "" + this.eventName + eventNameSuffix + "->" + this.identifier + "#" + this.methodName;
    };
    Object.defineProperty(Action.prototype, "eventTargetName", {
        get: function() {
            return (0, $5697ba647c0b1663$export$51f7ca27b47bde29)(this.eventTarget);
        },
        enumerable: false,
        configurable: true
    });
    return Action;
}();
var $8f5752b1045c2551$var$defaultEventNames = {
    "a": function(e) {
        return "click";
    },
    "button": function(e) {
        return "click";
    },
    "form": function(e) {
        return "submit";
    },
    "input": function(e) {
        return e.getAttribute("type") == "submit" ? "click" : "input";
    },
    "select": function(e) {
        return "change";
    },
    "textarea": function(e) {
        return "input";
    }
};
function $8f5752b1045c2551$export$1434b6878b59a330(element) {
    var tagName = element.tagName.toLowerCase();
    if (tagName in $8f5752b1045c2551$var$defaultEventNames) return $8f5752b1045c2551$var$defaultEventNames[tagName](element);
}
function $8f5752b1045c2551$var$error(message) {
    throw new Error(message);
}


var $3e34f8aec3544177$export$f4f50f872cf9bd86 = /** @class */ function() {
    function Binding(context, action) {
        this.context = context;
        this.action = action;
    }
    Object.defineProperty(Binding.prototype, "index", {
        get: function() {
            return this.action.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Binding.prototype, "eventTarget", {
        get: function() {
            return this.action.eventTarget;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Binding.prototype, "eventOptions", {
        get: function() {
            return this.action.eventOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Binding.prototype, "identifier", {
        get: function() {
            return this.context.identifier;
        },
        enumerable: false,
        configurable: true
    });
    Binding.prototype.handleEvent = function(event) {
        if (this.willBeInvokedByEvent(event)) this.invokeWithEvent(event);
    };
    Object.defineProperty(Binding.prototype, "eventName", {
        get: function() {
            return this.action.eventName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Binding.prototype, "method", {
        get: function() {
            var method = this.controller[this.methodName];
            if (typeof method == "function") return method;
            throw new Error("Action \"" + this.action + "\" references undefined method \"" + this.methodName + "\"");
        },
        enumerable: false,
        configurable: true
    });
    Binding.prototype.invokeWithEvent = function(event) {
        try {
            this.method.call(this.controller, event);
        } catch (error) {
            var _a = this, identifier = _a.identifier, controller = _a.controller, element = _a.element, index = _a.index;
            var detail = {
                identifier: identifier,
                controller: controller,
                element: element,
                index: index,
                event: event
            };
            this.context.handleError(error, "invoking action \"" + this.action + "\"", detail);
        }
    };
    Binding.prototype.willBeInvokedByEvent = function(event) {
        var eventTarget = event.target;
        if (this.element === eventTarget) return true;
        else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
        else return this.scope.containsElement(this.action.element);
    };
    Object.defineProperty(Binding.prototype, "controller", {
        get: function() {
            return this.context.controller;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Binding.prototype, "methodName", {
        get: function() {
            return this.action.methodName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Binding.prototype, "element", {
        get: function() {
            return this.scope.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Binding.prototype, "scope", {
        get: function() {
            return this.context.scope;
        },
        enumerable: false,
        configurable: true
    });
    return Binding;
}();


var $28e2029f0d937425$export$12e07a2a9f87578a = /** @class */ function() {
    function ElementObserver(element, delegate) {
        var _this = this;
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set;
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    ElementObserver.prototype.start = function() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true,
                childList: true,
                subtree: true
            });
            this.refresh();
        }
    };
    ElementObserver.prototype.stop = function() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    };
    ElementObserver.prototype.refresh = function() {
        if (this.started) {
            var matches = new Set(this.matchElementsInTree());
            for(var _i = 0, _a = Array.from(this.elements); _i < _a.length; _i++){
                var element = _a[_i];
                if (!matches.has(element)) this.removeElement(element);
            }
            for(var _b = 0, _c = Array.from(matches); _b < _c.length; _b++){
                var element = _c[_b];
                this.addElement(element);
            }
        }
    };
    // Mutation record processing
    ElementObserver.prototype.processMutations = function(mutations) {
        if (this.started) for(var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++){
            var mutation = mutations_1[_i];
            this.processMutation(mutation);
        }
    };
    ElementObserver.prototype.processMutation = function(mutation) {
        if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
        else if (mutation.type == "childList") {
            this.processRemovedNodes(mutation.removedNodes);
            this.processAddedNodes(mutation.addedNodes);
        }
    };
    ElementObserver.prototype.processAttributeChange = function(node, attributeName) {
        var element = node;
        if (this.elements.has(element)) {
            if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
            else this.removeElement(element);
        } else if (this.matchElement(element)) this.addElement(element);
    };
    ElementObserver.prototype.processRemovedNodes = function(nodes) {
        for(var _i = 0, _a = Array.from(nodes); _i < _a.length; _i++){
            var node = _a[_i];
            var element = this.elementFromNode(node);
            if (element) this.processTree(element, this.removeElement);
        }
    };
    ElementObserver.prototype.processAddedNodes = function(nodes) {
        for(var _i = 0, _a = Array.from(nodes); _i < _a.length; _i++){
            var node = _a[_i];
            var element = this.elementFromNode(node);
            if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
        }
    };
    // Element matching
    ElementObserver.prototype.matchElement = function(element) {
        return this.delegate.matchElement(element);
    };
    ElementObserver.prototype.matchElementsInTree = function(tree) {
        if (tree === void 0) tree = this.element;
        return this.delegate.matchElementsInTree(tree);
    };
    ElementObserver.prototype.processTree = function(tree, processor) {
        for(var _i = 0, _a = this.matchElementsInTree(tree); _i < _a.length; _i++){
            var element = _a[_i];
            processor.call(this, element);
        }
    };
    ElementObserver.prototype.elementFromNode = function(node) {
        if (node.nodeType == Node.ELEMENT_NODE) return node;
    };
    ElementObserver.prototype.elementIsActive = function(element) {
        if (element.isConnected != this.element.isConnected) return false;
        else return this.element.contains(element);
    };
    // Element tracking
    ElementObserver.prototype.addElement = function(element) {
        if (!this.elements.has(element)) {
            if (this.elementIsActive(element)) {
                this.elements.add(element);
                if (this.delegate.elementMatched) this.delegate.elementMatched(element);
            }
        }
    };
    ElementObserver.prototype.removeElement = function(element) {
        if (this.elements.has(element)) {
            this.elements.delete(element);
            if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
        }
    };
    return ElementObserver;
}();


var $9b2111ba185b0ab0$export$fe68319d413d05cb = /** @class */ function() {
    function AttributeObserver(element, attributeName, delegate) {
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new (0, $28e2029f0d937425$export$12e07a2a9f87578a)(element, this);
    }
    Object.defineProperty(AttributeObserver.prototype, "element", {
        get: function() {
            return this.elementObserver.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttributeObserver.prototype, "selector", {
        get: function() {
            return "[" + this.attributeName + "]";
        },
        enumerable: false,
        configurable: true
    });
    AttributeObserver.prototype.start = function() {
        this.elementObserver.start();
    };
    AttributeObserver.prototype.stop = function() {
        this.elementObserver.stop();
    };
    AttributeObserver.prototype.refresh = function() {
        this.elementObserver.refresh();
    };
    Object.defineProperty(AttributeObserver.prototype, "started", {
        get: function() {
            return this.elementObserver.started;
        },
        enumerable: false,
        configurable: true
    });
    // Element observer delegate
    AttributeObserver.prototype.matchElement = function(element) {
        return element.hasAttribute(this.attributeName);
    };
    AttributeObserver.prototype.matchElementsInTree = function(tree) {
        var match = this.matchElement(tree) ? [
            tree
        ] : [];
        var matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
    };
    AttributeObserver.prototype.elementMatched = function(element) {
        if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
    };
    AttributeObserver.prototype.elementUnmatched = function(element) {
        if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
    };
    AttributeObserver.prototype.elementAttributeChanged = function(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
    };
    return AttributeObserver;
}();



var $fb31d0affd8b843b$export$da226bebbf7f6caa = /** @class */ function() {
    function StringMapObserver(element, delegate) {
        var _this = this;
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map;
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    StringMapObserver.prototype.start = function() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true
            });
            this.refresh();
        }
    };
    StringMapObserver.prototype.stop = function() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    };
    StringMapObserver.prototype.refresh = function() {
        if (this.started) for(var _i = 0, _a = this.knownAttributeNames; _i < _a.length; _i++){
            var attributeName = _a[_i];
            this.refreshAttribute(attributeName);
        }
    };
    // Mutation record processing
    StringMapObserver.prototype.processMutations = function(mutations) {
        if (this.started) for(var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++){
            var mutation = mutations_1[_i];
            this.processMutation(mutation);
        }
    };
    StringMapObserver.prototype.processMutation = function(mutation) {
        var attributeName = mutation.attributeName;
        if (attributeName) this.refreshAttribute(attributeName);
    };
    // State tracking
    StringMapObserver.prototype.refreshAttribute = function(attributeName) {
        var key = this.delegate.getStringMapKeyForAttribute(attributeName);
        if (key != null) {
            if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
            var value = this.element.getAttribute(attributeName);
            if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key);
            if (value == null) {
                this.stringMap.delete(attributeName);
                this.stringMapKeyRemoved(key, attributeName);
            } else this.stringMap.set(attributeName, value);
        }
    };
    StringMapObserver.prototype.stringMapKeyAdded = function(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
    };
    StringMapObserver.prototype.stringMapValueChanged = function(value, key) {
        if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key);
    };
    StringMapObserver.prototype.stringMapKeyRemoved = function(key, attributeName) {
        if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName);
    };
    Object.defineProperty(StringMapObserver.prototype, "knownAttributeNames", {
        get: function() {
            return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StringMapObserver.prototype, "currentAttributeNames", {
        get: function() {
            return Array.from(this.element.attributes).map(function(attribute) {
                return attribute.name;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StringMapObserver.prototype, "recordedAttributeNames", {
        get: function() {
            return Array.from(this.stringMap.keys());
        },
        enumerable: false,
        configurable: true
    });
    return StringMapObserver;
}();



function $0b93927c94c66627$export$e16d8520af44a096(map, key, value) {
    $0b93927c94c66627$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $0b93927c94c66627$export$1d2f21e549771e67(map, key, value) {
    $0b93927c94c66627$export$e7aa7bc5c1b3cfb3(map, key).delete(value);
    $0b93927c94c66627$export$d6cf75919f12ca5a(map, key);
}
function $0b93927c94c66627$export$e7aa7bc5c1b3cfb3(map, key) {
    var values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $0b93927c94c66627$export$d6cf75919f12ca5a(map, key) {
    var values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}


var $66a11f81954dda8c$export$8bd4ad37b76db6ba = /** @class */ function() {
    function Multimap() {
        this.valuesByKey = new Map();
    }
    Object.defineProperty(Multimap.prototype, "values", {
        get: function() {
            var sets = Array.from(this.valuesByKey.values());
            return sets.reduce(function(values, set) {
                return values.concat(Array.from(set));
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multimap.prototype, "size", {
        get: function() {
            var sets = Array.from(this.valuesByKey.values());
            return sets.reduce(function(size, set) {
                return size + set.size;
            }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Multimap.prototype.add = function(key, value) {
        (0, $0b93927c94c66627$export$e16d8520af44a096)(this.valuesByKey, key, value);
    };
    Multimap.prototype.delete = function(key, value) {
        (0, $0b93927c94c66627$export$1d2f21e549771e67)(this.valuesByKey, key, value);
    };
    Multimap.prototype.has = function(key, value) {
        var values = this.valuesByKey.get(key);
        return values != null && values.has(value);
    };
    Multimap.prototype.hasKey = function(key) {
        return this.valuesByKey.has(key);
    };
    Multimap.prototype.hasValue = function(value) {
        var sets = Array.from(this.valuesByKey.values());
        return sets.some(function(set) {
            return set.has(value);
        });
    };
    Multimap.prototype.getValuesForKey = function(key) {
        var values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
    };
    Multimap.prototype.getKeysForValue = function(value) {
        return Array.from(this.valuesByKey).filter(function(_a) {
            var key = _a[0], values = _a[1];
            return values.has(value);
        }).map(function(_a) {
            var key = _a[0], values = _a[1];
            return key;
        });
    };
    return Multimap;
}();



var $248d9b3f9ba4839b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $248d9b3f9ba4839b$export$a7c3d2c2552a674d = /** @class */ function(_super) {
    $248d9b3f9ba4839b$var$__extends(IndexedMultimap, _super);
    function IndexedMultimap() {
        var _this = _super.call(this) || this;
        _this.keysByValue = new Map;
        return _this;
    }
    Object.defineProperty(IndexedMultimap.prototype, "values", {
        get: function() {
            return Array.from(this.keysByValue.keys());
        },
        enumerable: false,
        configurable: true
    });
    IndexedMultimap.prototype.add = function(key, value) {
        _super.prototype.add.call(this, key, value);
        (0, $0b93927c94c66627$export$e16d8520af44a096)(this.keysByValue, value, key);
    };
    IndexedMultimap.prototype.delete = function(key, value) {
        _super.prototype.delete.call(this, key, value);
        (0, $0b93927c94c66627$export$1d2f21e549771e67)(this.keysByValue, value, key);
    };
    IndexedMultimap.prototype.hasValue = function(value) {
        return this.keysByValue.has(value);
    };
    IndexedMultimap.prototype.getKeysForValue = function(value) {
        var set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
    };
    return IndexedMultimap;
}((0, $66a11f81954dda8c$export$8bd4ad37b76db6ba));






var $ffd80eaa7db43602$export$3aa21c2f03ef6b3b = /** @class */ function() {
    function TokenListObserver(element, attributeName, delegate) {
        this.attributeObserver = new (0, $9b2111ba185b0ab0$export$fe68319d413d05cb)(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new (0, $66a11f81954dda8c$export$8bd4ad37b76db6ba);
    }
    Object.defineProperty(TokenListObserver.prototype, "started", {
        get: function() {
            return this.attributeObserver.started;
        },
        enumerable: false,
        configurable: true
    });
    TokenListObserver.prototype.start = function() {
        this.attributeObserver.start();
    };
    TokenListObserver.prototype.stop = function() {
        this.attributeObserver.stop();
    };
    TokenListObserver.prototype.refresh = function() {
        this.attributeObserver.refresh();
    };
    Object.defineProperty(TokenListObserver.prototype, "element", {
        get: function() {
            return this.attributeObserver.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenListObserver.prototype, "attributeName", {
        get: function() {
            return this.attributeObserver.attributeName;
        },
        enumerable: false,
        configurable: true
    });
    // Attribute observer delegate
    TokenListObserver.prototype.elementMatchedAttribute = function(element) {
        this.tokensMatched(this.readTokensForElement(element));
    };
    TokenListObserver.prototype.elementAttributeValueChanged = function(element) {
        var _a = this.refreshTokensForElement(element), unmatchedTokens = _a[0], matchedTokens = _a[1];
        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
    };
    TokenListObserver.prototype.elementUnmatchedAttribute = function(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
    };
    TokenListObserver.prototype.tokensMatched = function(tokens) {
        var _this = this;
        tokens.forEach(function(token) {
            return _this.tokenMatched(token);
        });
    };
    TokenListObserver.prototype.tokensUnmatched = function(tokens) {
        var _this = this;
        tokens.forEach(function(token) {
            return _this.tokenUnmatched(token);
        });
    };
    TokenListObserver.prototype.tokenMatched = function(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
    };
    TokenListObserver.prototype.tokenUnmatched = function(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
    };
    TokenListObserver.prototype.refreshTokensForElement = function(element) {
        var previousTokens = this.tokensByElement.getValuesForKey(element);
        var currentTokens = this.readTokensForElement(element);
        var firstDifferingIndex = $ffd80eaa7db43602$var$zip(previousTokens, currentTokens).findIndex(function(_a) {
            var previousToken = _a[0], currentToken = _a[1];
            return !$ffd80eaa7db43602$var$tokensAreEqual(previousToken, currentToken);
        });
        if (firstDifferingIndex == -1) return [
            [],
            []
        ];
        else return [
            previousTokens.slice(firstDifferingIndex),
            currentTokens.slice(firstDifferingIndex)
        ];
    };
    TokenListObserver.prototype.readTokensForElement = function(element) {
        var attributeName = this.attributeName;
        var tokenString = element.getAttribute(attributeName) || "";
        return $ffd80eaa7db43602$var$parseTokenString(tokenString, element, attributeName);
    };
    return TokenListObserver;
}();
function $ffd80eaa7db43602$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter(function(content) {
        return content.length;
    }).map(function(content, index) {
        return {
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        };
    });
}
function $ffd80eaa7db43602$var$zip(left, right) {
    var length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, function(_, index) {
        return [
            left[index],
            right[index]
        ];
    });
}
function $ffd80eaa7db43602$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}



var $449f4d7fa6608136$export$d27fa4c7330a452e = /** @class */ function() {
    function ValueListObserver(element, attributeName, delegate) {
        this.tokenListObserver = new (0, $ffd80eaa7db43602$export$3aa21c2f03ef6b3b)(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap;
        this.valuesByTokenByElement = new WeakMap;
    }
    Object.defineProperty(ValueListObserver.prototype, "started", {
        get: function() {
            return this.tokenListObserver.started;
        },
        enumerable: false,
        configurable: true
    });
    ValueListObserver.prototype.start = function() {
        this.tokenListObserver.start();
    };
    ValueListObserver.prototype.stop = function() {
        this.tokenListObserver.stop();
    };
    ValueListObserver.prototype.refresh = function() {
        this.tokenListObserver.refresh();
    };
    Object.defineProperty(ValueListObserver.prototype, "element", {
        get: function() {
            return this.tokenListObserver.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValueListObserver.prototype, "attributeName", {
        get: function() {
            return this.tokenListObserver.attributeName;
        },
        enumerable: false,
        configurable: true
    });
    ValueListObserver.prototype.tokenMatched = function(token) {
        var element = token.element;
        var value = this.fetchParseResultForToken(token).value;
        if (value) {
            this.fetchValuesByTokenForElement(element).set(token, value);
            this.delegate.elementMatchedValue(element, value);
        }
    };
    ValueListObserver.prototype.tokenUnmatched = function(token) {
        var element = token.element;
        var value = this.fetchParseResultForToken(token).value;
        if (value) {
            this.fetchValuesByTokenForElement(element).delete(token);
            this.delegate.elementUnmatchedValue(element, value);
        }
    };
    ValueListObserver.prototype.fetchParseResultForToken = function(token) {
        var parseResult = this.parseResultsByToken.get(token);
        if (!parseResult) {
            parseResult = this.parseToken(token);
            this.parseResultsByToken.set(token, parseResult);
        }
        return parseResult;
    };
    ValueListObserver.prototype.fetchValuesByTokenForElement = function(element) {
        var valuesByToken = this.valuesByTokenByElement.get(element);
        if (!valuesByToken) {
            valuesByToken = new Map;
            this.valuesByTokenByElement.set(element, valuesByToken);
        }
        return valuesByToken;
    };
    ValueListObserver.prototype.parseToken = function(token) {
        try {
            var value = this.delegate.parseValueForToken(token);
            return {
                value: value
            };
        } catch (error) {
            return {
                error: error
            };
        }
    };
    return ValueListObserver;
}();




var $0315268c67ae5b22$export$a2c9cf231601bc00 = /** @class */ function() {
    function BindingObserver(context, delegate) {
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map;
    }
    BindingObserver.prototype.start = function() {
        if (!this.valueListObserver) {
            this.valueListObserver = new (0, $449f4d7fa6608136$export$d27fa4c7330a452e)(this.element, this.actionAttribute, this);
            this.valueListObserver.start();
        }
    };
    BindingObserver.prototype.stop = function() {
        if (this.valueListObserver) {
            this.valueListObserver.stop();
            delete this.valueListObserver;
            this.disconnectAllActions();
        }
    };
    Object.defineProperty(BindingObserver.prototype, "element", {
        get: function() {
            return this.context.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindingObserver.prototype, "identifier", {
        get: function() {
            return this.context.identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindingObserver.prototype, "actionAttribute", {
        get: function() {
            return this.schema.actionAttribute;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindingObserver.prototype, "schema", {
        get: function() {
            return this.context.schema;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindingObserver.prototype, "bindings", {
        get: function() {
            return Array.from(this.bindingsByAction.values());
        },
        enumerable: false,
        configurable: true
    });
    BindingObserver.prototype.connectAction = function(action) {
        var binding = new (0, $3e34f8aec3544177$export$f4f50f872cf9bd86)(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
    };
    BindingObserver.prototype.disconnectAction = function(action) {
        var binding = this.bindingsByAction.get(action);
        if (binding) {
            this.bindingsByAction.delete(action);
            this.delegate.bindingDisconnected(binding);
        }
    };
    BindingObserver.prototype.disconnectAllActions = function() {
        var _this = this;
        this.bindings.forEach(function(binding) {
            return _this.delegate.bindingDisconnected(binding);
        });
        this.bindingsByAction.clear();
    };
    // Value observer delegate
    BindingObserver.prototype.parseValueForToken = function(token) {
        var action = (0, $8f5752b1045c2551$export$e19cd5f9376f8cee).forToken(token);
        if (action.identifier == this.identifier) return action;
    };
    BindingObserver.prototype.elementMatchedValue = function(element, action) {
        this.connectAction(action);
    };
    BindingObserver.prototype.elementUnmatchedValue = function(element, action) {
        this.disconnectAction(action);
    };
    return BindingObserver;
}();



var $9fa86b7860c27cd5$export$4fe3f81c0be3b20d = /** @class */ function() {
    function ValueObserver(context, receiver) {
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new (0, $fb31d0affd8b843b$export$da226bebbf7f6caa)(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
        this.invokeChangedCallbacksForDefaultValues();
    }
    ValueObserver.prototype.start = function() {
        this.stringMapObserver.start();
    };
    ValueObserver.prototype.stop = function() {
        this.stringMapObserver.stop();
    };
    Object.defineProperty(ValueObserver.prototype, "element", {
        get: function() {
            return this.context.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValueObserver.prototype, "controller", {
        get: function() {
            return this.context.controller;
        },
        enumerable: false,
        configurable: true
    });
    // String map observer delegate
    ValueObserver.prototype.getStringMapKeyForAttribute = function(attributeName) {
        if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
    };
    ValueObserver.prototype.stringMapValueChanged = function(attributeValue, name) {
        this.invokeChangedCallbackForValue(name);
    };
    ValueObserver.prototype.invokeChangedCallbacksForDefaultValues = function() {
        for(var _i = 0, _a = this.valueDescriptors; _i < _a.length; _i++){
            var _b = _a[_i], key = _b.key, name_1 = _b.name, defaultValue = _b.defaultValue;
            if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallbackForValue(name_1);
        }
    };
    ValueObserver.prototype.invokeChangedCallbackForValue = function(name) {
        var methodName = name + "Changed";
        var method = this.receiver[methodName];
        if (typeof method == "function") {
            var value = this.receiver[name];
            method.call(this.receiver, value);
        }
    };
    Object.defineProperty(ValueObserver.prototype, "valueDescriptors", {
        get: function() {
            var valueDescriptorMap = this.valueDescriptorMap;
            return Object.keys(valueDescriptorMap).map(function(key) {
                return valueDescriptorMap[key];
            });
        },
        enumerable: false,
        configurable: true
    });
    return ValueObserver;
}();


var $8a24e163940e16c8$export$841858b892ce1f4c = /** @class */ function() {
    function Context(module, scope) {
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new (0, $0315268c67ae5b22$export$a2c9cf231601bc00)(this, this.dispatcher);
        this.valueObserver = new (0, $9fa86b7860c27cd5$export$4fe3f81c0be3b20d)(this, this.controller);
        try {
            this.controller.initialize();
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    Context.prototype.connect = function() {
        this.bindingObserver.start();
        this.valueObserver.start();
        try {
            this.controller.connect();
        } catch (error) {
            this.handleError(error, "connecting controller");
        }
    };
    Context.prototype.disconnect = function() {
        try {
            this.controller.disconnect();
        } catch (error) {
            this.handleError(error, "disconnecting controller");
        }
        this.valueObserver.stop();
        this.bindingObserver.stop();
    };
    Object.defineProperty(Context.prototype, "application", {
        get: function() {
            return this.module.application;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "identifier", {
        get: function() {
            return this.module.identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "schema", {
        get: function() {
            return this.application.schema;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "dispatcher", {
        get: function() {
            return this.application.dispatcher;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "element", {
        get: function() {
            return this.scope.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "parentElement", {
        get: function() {
            return this.element.parentElement;
        },
        enumerable: false,
        configurable: true
    });
    // Error handling
    Context.prototype.handleError = function(error, message, detail) {
        if (detail === void 0) detail = {};
        var _a = this, identifier = _a.identifier, controller = _a.controller, element = _a.element;
        detail = Object.assign({
            identifier: identifier,
            controller: controller,
            element: element
        }, detail);
        this.application.handleError(error, "Error " + message, detail);
    };
    return Context;
}();


function $15bf50cb8fe03119$export$71cc8d1f3ffd140c(constructor, propertyName) {
    var ancestors = $15bf50cb8fe03119$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce(function(values, constructor) {
        $15bf50cb8fe03119$var$getOwnStaticArrayValues(constructor, propertyName).forEach(function(name) {
            return values.add(name);
        });
        return values;
    }, new Set));
}
function $15bf50cb8fe03119$export$de34cf4babd9196b(constructor, propertyName) {
    var ancestors = $15bf50cb8fe03119$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce(function(pairs, constructor) {
        pairs.push.apply(pairs, $15bf50cb8fe03119$var$getOwnStaticObjectPairs(constructor, propertyName));
        return pairs;
    }, []);
}
function $15bf50cb8fe03119$var$getAncestorsForConstructor(constructor) {
    var ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $15bf50cb8fe03119$var$getOwnStaticArrayValues(constructor, propertyName) {
    var definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $15bf50cb8fe03119$var$getOwnStaticObjectPairs(constructor, propertyName) {
    var definition = constructor[propertyName];
    return definition ? Object.keys(definition).map(function(key) {
        return [
            key,
            definition[key]
        ];
    }) : [];
}


var $77dcc447bbadc520$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $77dcc447bbadc520$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
function $77dcc447bbadc520$export$31b95cad1d08f446(constructor) {
    return $77dcc447bbadc520$var$shadow(constructor, $77dcc447bbadc520$var$getBlessedProperties(constructor));
}
function $77dcc447bbadc520$var$shadow(constructor, properties) {
    var shadowConstructor = $77dcc447bbadc520$var$extend(constructor);
    var shadowProperties = $77dcc447bbadc520$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $77dcc447bbadc520$var$getBlessedProperties(constructor) {
    var blessings = (0, $15bf50cb8fe03119$export$71cc8d1f3ffd140c)(constructor, "blessings");
    return blessings.reduce(function(blessedProperties, blessing) {
        var properties = blessing(constructor);
        for(var key in properties){
            var descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $77dcc447bbadc520$var$getShadowProperties(prototype, properties) {
    return $77dcc447bbadc520$var$getOwnKeys(properties).reduce(function(shadowProperties, key) {
        var _a;
        var descriptor = $77dcc447bbadc520$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, (_a = {}, _a[key] = descriptor, _a));
        return shadowProperties;
    }, {});
}
function $77dcc447bbadc520$var$getShadowedDescriptor(prototype, properties, key) {
    var shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    var shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        var descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
var $77dcc447bbadc520$var$getOwnKeys = function() {
    if (typeof Object.getOwnPropertySymbols == "function") return function(object) {
        return $77dcc447bbadc520$var$__spreadArrays(Object.getOwnPropertyNames(object), Object.getOwnPropertySymbols(object));
    };
    else return Object.getOwnPropertyNames;
}();
var $77dcc447bbadc520$var$extend = function() {
    function extendWithReflect(constructor) {
        function extended() {
            var _newTarget = this && this instanceof extended ? this.constructor : void 0;
            return Reflect.construct(constructor, arguments, _newTarget);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        var a = function() {
            this.a.call(this);
        };
        var b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b;
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return function(constructor) {
            return /** @class */ function(_super) {
                $77dcc447bbadc520$var$__extends(extended, _super);
                function extended() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return extended;
            }(constructor);
        };
    }
}();


function $fb404d02e6871da5$export$a91f79a25bab6882(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: (0, $77dcc447bbadc520$export$31b95cad1d08f446)(definition.controllerConstructor)
    };
}


var $e9bd0bd3a5289226$export$c3a9d7ff17e4f3ed = /** @class */ function() {
    function Module(application, definition) {
        this.application = application;
        this.definition = (0, $fb404d02e6871da5$export$a91f79a25bab6882)(definition);
        this.contextsByScope = new WeakMap;
        this.connectedContexts = new Set;
    }
    Object.defineProperty(Module.prototype, "identifier", {
        get: function() {
            return this.definition.identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "controllerConstructor", {
        get: function() {
            return this.definition.controllerConstructor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "contexts", {
        get: function() {
            return Array.from(this.connectedContexts);
        },
        enumerable: false,
        configurable: true
    });
    Module.prototype.connectContextForScope = function(scope) {
        var context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
    };
    Module.prototype.disconnectContextForScope = function(scope) {
        var context = this.contextsByScope.get(scope);
        if (context) {
            this.connectedContexts.delete(context);
            context.disconnect();
        }
    };
    Module.prototype.fetchContextForScope = function(scope) {
        var context = this.contextsByScope.get(scope);
        if (!context) {
            context = new (0, $8a24e163940e16c8$export$841858b892ce1f4c)(this, scope);
            this.contextsByScope.set(scope, context);
        }
        return context;
    };
    return Module;
}();



var $788fd32ddef2b326$export$959d518cf04a234c = /** @class */ function() {
    function ClassMap(scope) {
        this.scope = scope;
    }
    ClassMap.prototype.has = function(name) {
        return this.data.has(this.getDataKey(name));
    };
    ClassMap.prototype.get = function(name) {
        return this.data.get(this.getDataKey(name));
    };
    ClassMap.prototype.getAttributeName = function(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
    };
    ClassMap.prototype.getDataKey = function(name) {
        return name + "-class";
    };
    Object.defineProperty(ClassMap.prototype, "data", {
        get: function() {
            return this.scope.data;
        },
        enumerable: false,
        configurable: true
    });
    return ClassMap;
}();


function $723baa9467d74429$export$161d051f5dd25de7(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, function(_, char) {
        return char.toUpperCase();
    });
}
function $723baa9467d74429$export$9a00dee1beb8f576(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $723baa9467d74429$export$7e9152eee80b168f(value) {
    return value.replace(/([A-Z])/g, function(_, char) {
        return "-" + char.toLowerCase();
    });
}


var $52424994dbad1c6d$export$4f44abf55772883f = /** @class */ function() {
    function DataMap(scope) {
        this.scope = scope;
    }
    Object.defineProperty(DataMap.prototype, "element", {
        get: function() {
            return this.scope.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataMap.prototype, "identifier", {
        get: function() {
            return this.scope.identifier;
        },
        enumerable: false,
        configurable: true
    });
    DataMap.prototype.get = function(key) {
        var name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
    };
    DataMap.prototype.set = function(key, value) {
        var name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
    };
    DataMap.prototype.has = function(key) {
        var name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
    };
    DataMap.prototype.delete = function(key) {
        if (this.has(key)) {
            var name_1 = this.getAttributeNameForKey(key);
            this.element.removeAttribute(name_1);
            return true;
        } else return false;
    };
    DataMap.prototype.getAttributeNameForKey = function(key) {
        return "data-" + this.identifier + "-" + (0, $723baa9467d74429$export$7e9152eee80b168f)(key);
    };
    return DataMap;
}();


var $927fecb8b3cd1825$export$dd9cef36367ff841 = /** @class */ function() {
    function Guide(logger) {
        this.warnedKeysByObject = new WeakMap;
        this.logger = logger;
    }
    Guide.prototype.warn = function(object, key, message) {
        var warnedKeys = this.warnedKeysByObject.get(object);
        if (!warnedKeys) {
            warnedKeys = new Set;
            this.warnedKeysByObject.set(object, warnedKeys);
        }
        if (!warnedKeys.has(key)) {
            warnedKeys.add(key);
            this.logger.warn(message, object);
        }
    };
    return Guide;
}();


/** @hidden */ function $8a0af7dace3d2c97$export$9f90da964d33e37d(attributeName, token) {
    return "[" + attributeName + "~=\"" + token + "\"]";
}



var $354594280145dd44$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $354594280145dd44$export$26ee2af0234008d2 = /** @class */ function() {
    function TargetSet(scope) {
        this.scope = scope;
    }
    Object.defineProperty(TargetSet.prototype, "element", {
        get: function() {
            return this.scope.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetSet.prototype, "identifier", {
        get: function() {
            return this.scope.identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetSet.prototype, "schema", {
        get: function() {
            return this.scope.schema;
        },
        enumerable: false,
        configurable: true
    });
    TargetSet.prototype.has = function(targetName) {
        return this.find(targetName) != null;
    };
    TargetSet.prototype.find = function() {
        var _this = this;
        var targetNames = [];
        for(var _i = 0; _i < arguments.length; _i++)targetNames[_i] = arguments[_i];
        return targetNames.reduce(function(target, targetName) {
            return target || _this.findTarget(targetName) || _this.findLegacyTarget(targetName);
        }, undefined);
    };
    TargetSet.prototype.findAll = function() {
        var _this = this;
        var targetNames = [];
        for(var _i = 0; _i < arguments.length; _i++)targetNames[_i] = arguments[_i];
        return targetNames.reduce(function(targets, targetName) {
            return $354594280145dd44$var$__spreadArrays(targets, _this.findAllTargets(targetName), _this.findAllLegacyTargets(targetName));
        }, []);
    };
    TargetSet.prototype.findTarget = function(targetName) {
        var selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
    };
    TargetSet.prototype.findAllTargets = function(targetName) {
        var selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
    };
    TargetSet.prototype.getSelectorForTargetName = function(targetName) {
        var attributeName = "data-" + this.identifier + "-target";
        return (0, $8a0af7dace3d2c97$export$9f90da964d33e37d)(attributeName, targetName);
    };
    TargetSet.prototype.findLegacyTarget = function(targetName) {
        var selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
    };
    TargetSet.prototype.findAllLegacyTargets = function(targetName) {
        var _this = this;
        var selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map(function(element) {
            return _this.deprecate(element, targetName);
        });
    };
    TargetSet.prototype.getLegacySelectorForTargetName = function(targetName) {
        var targetDescriptor = this.identifier + "." + targetName;
        return (0, $8a0af7dace3d2c97$export$9f90da964d33e37d)(this.schema.targetAttribute, targetDescriptor);
    };
    TargetSet.prototype.deprecate = function(element, targetName) {
        if (element) {
            var identifier = this.identifier;
            var attributeName = this.schema.targetAttribute;
            this.guide.warn(element, "target:" + targetName, "Please replace " + attributeName + "=\"" + identifier + "." + targetName + "\" with data-" + identifier + "-target=\"" + targetName + "\". " + ("The " + attributeName + " attribute is deprecated and will be removed in a future version of Stimulus."));
        }
        return element;
    };
    Object.defineProperty(TargetSet.prototype, "guide", {
        get: function() {
            return this.scope.guide;
        },
        enumerable: false,
        configurable: true
    });
    return TargetSet;
}();


var $637b2331442a7afa$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $637b2331442a7afa$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope(schema, element, identifier, logger) {
        var _this = this;
        this.targets = new (0, $354594280145dd44$export$26ee2af0234008d2)(this);
        this.classes = new (0, $788fd32ddef2b326$export$959d518cf04a234c)(this);
        this.data = new (0, $52424994dbad1c6d$export$4f44abf55772883f)(this);
        this.containsElement = function(element) {
            return element.closest(_this.controllerSelector) === _this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new (0, $927fecb8b3cd1825$export$dd9cef36367ff841)(logger);
    }
    Scope.prototype.findElement = function(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
    };
    Scope.prototype.findAllElements = function(selector) {
        return $637b2331442a7afa$var$__spreadArrays(this.element.matches(selector) ? [
            this.element
        ] : [], this.queryElements(selector).filter(this.containsElement));
    };
    Scope.prototype.queryElements = function(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    };
    Object.defineProperty(Scope.prototype, "controllerSelector", {
        get: function() {
            return (0, $8a0af7dace3d2c97$export$9f90da964d33e37d)(this.schema.controllerAttribute, this.identifier);
        },
        enumerable: false,
        configurable: true
    });
    return Scope;
}();



var $3560f5757a8aa24d$export$1b0e56f9adcd0f9c = /** @class */ function() {
    function ScopeObserver(element, schema, delegate) {
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new (0, $449f4d7fa6608136$export$d27fa4c7330a452e)(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap;
        this.scopeReferenceCounts = new WeakMap;
    }
    ScopeObserver.prototype.start = function() {
        this.valueListObserver.start();
    };
    ScopeObserver.prototype.stop = function() {
        this.valueListObserver.stop();
    };
    Object.defineProperty(ScopeObserver.prototype, "controllerAttribute", {
        get: function() {
            return this.schema.controllerAttribute;
        },
        enumerable: false,
        configurable: true
    });
    // Value observer delegate
    /** @hidden */ ScopeObserver.prototype.parseValueForToken = function(token) {
        var element = token.element, identifier = token.content;
        var scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        var scope = scopesByIdentifier.get(identifier);
        if (!scope) {
            scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
            scopesByIdentifier.set(identifier, scope);
        }
        return scope;
    };
    /** @hidden */ ScopeObserver.prototype.elementMatchedValue = function(element, value) {
        var referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);
        if (referenceCount == 1) this.delegate.scopeConnected(value);
    };
    /** @hidden */ ScopeObserver.prototype.elementUnmatchedValue = function(element, value) {
        var referenceCount = this.scopeReferenceCounts.get(value);
        if (referenceCount) {
            this.scopeReferenceCounts.set(value, referenceCount - 1);
            if (referenceCount == 1) this.delegate.scopeDisconnected(value);
        }
    };
    ScopeObserver.prototype.fetchScopesByIdentifierForElement = function(element) {
        var scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
        if (!scopesByIdentifier) {
            scopesByIdentifier = new Map;
            this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }
        return scopesByIdentifier;
    };
    return ScopeObserver;
}();


var $a4a64ad833f4b46f$export$55185c17a0fcbe46 = /** @class */ function() {
    function Router(application) {
        this.application = application;
        this.scopeObserver = new (0, $3560f5757a8aa24d$export$1b0e56f9adcd0f9c)(this.element, this.schema, this);
        this.scopesByIdentifier = new (0, $66a11f81954dda8c$export$8bd4ad37b76db6ba);
        this.modulesByIdentifier = new Map;
    }
    Object.defineProperty(Router.prototype, "element", {
        get: function() {
            return this.application.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "schema", {
        get: function() {
            return this.application.schema;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "logger", {
        get: function() {
            return this.application.logger;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "controllerAttribute", {
        get: function() {
            return this.schema.controllerAttribute;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "modules", {
        get: function() {
            return Array.from(this.modulesByIdentifier.values());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "contexts", {
        get: function() {
            return this.modules.reduce(function(contexts, module) {
                return contexts.concat(module.contexts);
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Router.prototype.start = function() {
        this.scopeObserver.start();
    };
    Router.prototype.stop = function() {
        this.scopeObserver.stop();
    };
    Router.prototype.loadDefinition = function(definition) {
        this.unloadIdentifier(definition.identifier);
        var module = new (0, $e9bd0bd3a5289226$export$c3a9d7ff17e4f3ed)(this.application, definition);
        this.connectModule(module);
    };
    Router.prototype.unloadIdentifier = function(identifier) {
        var module = this.modulesByIdentifier.get(identifier);
        if (module) this.disconnectModule(module);
    };
    Router.prototype.getContextForElementAndIdentifier = function(element, identifier) {
        var module = this.modulesByIdentifier.get(identifier);
        if (module) return module.contexts.find(function(context) {
            return context.element == element;
        });
    };
    // Error handler delegate
    /** @hidden */ Router.prototype.handleError = function(error, message, detail) {
        this.application.handleError(error, message, detail);
    };
    // Scope observer delegate
    /** @hidden */ Router.prototype.createScopeForElementAndIdentifier = function(element, identifier) {
        return new (0, $637b2331442a7afa$export$775b6bb06e53a214)(this.schema, element, identifier, this.logger);
    };
    /** @hidden */ Router.prototype.scopeConnected = function(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        var module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.connectContextForScope(scope);
    };
    /** @hidden */ Router.prototype.scopeDisconnected = function(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        var module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.disconnectContextForScope(scope);
    };
    // Modules
    Router.prototype.connectModule = function(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach(function(scope) {
            return module.connectContextForScope(scope);
        });
    };
    Router.prototype.disconnectModule = function(module) {
        this.modulesByIdentifier.delete(module.identifier);
        var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach(function(scope) {
            return module.disconnectContextForScope(scope);
        });
    };
    return Router;
}();


var $010e74110fb8c43a$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target"
};


var $12bdc35e7457d4b6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $12bdc35e7457d4b6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $12bdc35e7457d4b6$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $12bdc35e7457d4b6$export$16975c34e60e1e61 = /** @class */ function() {
    function Application(element, schema) {
        if (element === void 0) element = document.documentElement;
        if (schema === void 0) schema = (0, $010e74110fb8c43a$export$1db618b7b2275ea1);
        this.logger = console;
        this.element = element;
        this.schema = schema;
        this.dispatcher = new (0, $a32b9e3914eee5c7$export$ab054a1ef92eeb01)(this);
        this.router = new (0, $a4a64ad833f4b46f$export$55185c17a0fcbe46)(this);
    }
    Application.start = function(element, schema) {
        var application = new Application(element, schema);
        application.start();
        return application;
    };
    Application.prototype.start = function() {
        return $12bdc35e7457d4b6$var$__awaiter(this, void 0, void 0, function() {
            return $12bdc35e7457d4b6$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $12bdc35e7457d4b6$var$domReady()
                        ];
                    case 1:
                        _a.sent();
                        this.dispatcher.start();
                        this.router.start();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Application.prototype.stop = function() {
        this.dispatcher.stop();
        this.router.stop();
    };
    Application.prototype.register = function(identifier, controllerConstructor) {
        this.load({
            identifier: identifier,
            controllerConstructor: controllerConstructor
        });
    };
    Application.prototype.load = function(head) {
        var _this = this;
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        var definitions = Array.isArray(head) ? head : $12bdc35e7457d4b6$var$__spreadArrays([
            head
        ], rest);
        definitions.forEach(function(definition) {
            return _this.router.loadDefinition(definition);
        });
    };
    Application.prototype.unload = function(head) {
        var _this = this;
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        var identifiers = Array.isArray(head) ? head : $12bdc35e7457d4b6$var$__spreadArrays([
            head
        ], rest);
        identifiers.forEach(function(identifier) {
            return _this.router.unloadIdentifier(identifier);
        });
    };
    Object.defineProperty(Application.prototype, "controllers", {
        // Controllers
        get: function() {
            return this.router.contexts.map(function(context) {
                return context.controller;
            });
        },
        enumerable: false,
        configurable: true
    });
    Application.prototype.getControllerForElementAndIdentifier = function(element, identifier) {
        var context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
    };
    // Error handling
    Application.prototype.handleError = function(error, message, detail) {
        this.logger.error("%s\n\n%o\n\n%o", message, error, detail);
    };
    return Application;
}();
function $12bdc35e7457d4b6$var$domReady() {
    return new Promise(function(resolve) {
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", resolve);
        else resolve();
    });
}





function $ff3cb6f777b05d7a$export$12eb5baa912bb63a(constructor) {
    var classes = (0, $15bf50cb8fe03119$export$71cc8d1f3ffd140c)(constructor, "classes");
    return classes.reduce(function(properties, classDefinition) {
        return Object.assign(properties, $ff3cb6f777b05d7a$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $ff3cb6f777b05d7a$var$propertiesForClassDefinition(key) {
    var _a;
    var name = key + "Class";
    return _a = {}, _a[name] = {
        get: function() {
            var classes = this.classes;
            if (classes.has(key)) return classes.get(key);
            else {
                var attribute = classes.getAttributeName(key);
                throw new Error("Missing attribute \"" + attribute + "\"");
            }
        }
    }, _a["has" + (0, $723baa9467d74429$export$9a00dee1beb8f576)(name)] = {
        get: function() {
            return this.classes.has(key);
        }
    }, _a;
}




function $ab2e87f70de5c16c$export$dafd4a5c7964bc98(constructor) {
    var targets = (0, $15bf50cb8fe03119$export$71cc8d1f3ffd140c)(constructor, "targets");
    return targets.reduce(function(properties, targetDefinition) {
        return Object.assign(properties, $ab2e87f70de5c16c$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $ab2e87f70de5c16c$var$propertiesForTargetDefinition(name) {
    var _a;
    return _a = {}, _a[name + "Target"] = {
        get: function() {
            var target = this.targets.find(name);
            if (target) return target;
            else throw new Error("Missing target element \"" + this.identifier + "." + name + "\"");
        }
    }, _a[name + "Targets"] = {
        get: function() {
            return this.targets.findAll(name);
        }
    }, _a["has" + (0, $723baa9467d74429$export$9a00dee1beb8f576)(name) + "Target"] = {
        get: function() {
            return this.targets.has(name);
        }
    }, _a;
}




function $8e2c992c2d5a4c9e$export$8731d477c906bf10(constructor) {
    var valueDefinitionPairs = (0, $15bf50cb8fe03119$export$de34cf4babd9196b)(constructor, "values");
    var propertyDescriptorMap = {
        valueDescriptorMap: {
            get: function() {
                var _this = this;
                return valueDefinitionPairs.reduce(function(result, valueDefinitionPair) {
                    var _a;
                    var valueDescriptor = $8e2c992c2d5a4c9e$var$parseValueDefinitionPair(valueDefinitionPair);
                    var attributeName = _this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, (_a = {}, _a[attributeName] = valueDescriptor, _a));
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce(function(properties, valueDefinitionPair) {
        return Object.assign(properties, $8e2c992c2d5a4c9e$export$cc01f95ef41b9ebe(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $8e2c992c2d5a4c9e$export$cc01f95ef41b9ebe(valueDefinitionPair) {
    var _a;
    var definition = $8e2c992c2d5a4c9e$var$parseValueDefinitionPair(valueDefinitionPair);
    var type = definition.type, key = definition.key, name = definition.name;
    var read = $8e2c992c2d5a4c9e$var$readers[type], write = $8e2c992c2d5a4c9e$var$writers[type] || $8e2c992c2d5a4c9e$var$writers.default;
    return _a = {}, _a[name] = {
        get: function() {
            var value = this.data.get(key);
            if (value !== null) return read(value);
            else return definition.defaultValue;
        },
        set: function(value) {
            if (value === undefined) this.data.delete(key);
            else this.data.set(key, write(value));
        }
    }, _a["has" + (0, $723baa9467d74429$export$9a00dee1beb8f576)(name)] = {
        get: function() {
            return this.data.has(key);
        }
    }, _a;
}
function $8e2c992c2d5a4c9e$var$parseValueDefinitionPair(_a) {
    var token = _a[0], typeConstant = _a[1];
    var type = $8e2c992c2d5a4c9e$var$parseValueTypeConstant(typeConstant);
    return $8e2c992c2d5a4c9e$var$valueDescriptorForTokenAndType(token, type);
}
function $8e2c992c2d5a4c9e$var$parseValueTypeConstant(typeConstant) {
    switch(typeConstant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
    throw new Error("Unknown value type constant \"" + typeConstant + "\"");
}
function $8e2c992c2d5a4c9e$var$valueDescriptorForTokenAndType(token, type) {
    var key = (0, $723baa9467d74429$export$7e9152eee80b168f)(token) + "-value";
    return {
        type: type,
        key: key,
        name: (0, $723baa9467d74429$export$161d051f5dd25de7)(key),
        get defaultValue () {
            return $8e2c992c2d5a4c9e$var$defaultValuesByType[type];
        }
    };
}
var $8e2c992c2d5a4c9e$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
var $8e2c992c2d5a4c9e$var$readers = {
    array: function(value) {
        var array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError("Expected array");
        return array;
    },
    boolean: function(value) {
        return !(value == "0" || value == "false");
    },
    number: function(value) {
        return parseFloat(value);
    },
    object: function(value) {
        var object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError("Expected object");
        return object;
    },
    string: function(value) {
        return value;
    }
};
var $8e2c992c2d5a4c9e$var$writers = {
    default: $8e2c992c2d5a4c9e$var$writeString,
    array: $8e2c992c2d5a4c9e$var$writeJSON,
    object: $8e2c992c2d5a4c9e$var$writeJSON
};
function $8e2c992c2d5a4c9e$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $8e2c992c2d5a4c9e$var$writeString(value) {
    return "" + value;
}


var $5d5f3550be2e7e43$export$bd0bf19f25da8474 = /** @class */ function() {
    function Controller(context) {
        this.context = context;
    }
    Object.defineProperty(Controller.prototype, "application", {
        get: function() {
            return this.context.application;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Controller.prototype, "scope", {
        get: function() {
            return this.context.scope;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Controller.prototype, "element", {
        get: function() {
            return this.scope.element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Controller.prototype, "identifier", {
        get: function() {
            return this.scope.identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Controller.prototype, "targets", {
        get: function() {
            return this.scope.targets;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Controller.prototype, "classes", {
        get: function() {
            return this.scope.classes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Controller.prototype, "data", {
        get: function() {
            return this.scope.data;
        },
        enumerable: false,
        configurable: true
    });
    Controller.prototype.initialize = function() {
    // Override in your subclass to set up initial controller state
    };
    Controller.prototype.connect = function() {
    // Override in your subclass to respond when the controller is connected to the DOM
    };
    Controller.prototype.disconnect = function() {
    // Override in your subclass to respond when the controller is disconnected from the DOM
    };
    Controller.blessings = [
        (0, $ff3cb6f777b05d7a$export$12eb5baa912bb63a),
        (0, $ab2e87f70de5c16c$export$dafd4a5c7964bc98),
        (0, $8e2c992c2d5a4c9e$export$8731d477c906bf10)
    ];
    Controller.targets = [];
    Controller.values = {};
    return Controller;
}();








class $4dd888bafdf04186$export$2e2bcd8739ae039 extends (0, $5d5f3550be2e7e43$export$bd0bf19f25da8474) {
    static get targets() {
        return [
            "input"
        ];
    }
    connect() {
        if (typeof Storage !== "undefined") {
            // TODO: migrate away from DataMaps to Values
            // https://web.archive.org/web/20200807015522if_/https://stimulusjs.org/reference/data-maps
            // https://stimulus.hotwired.dev/reference/values
            const val = sessionStorage.getItem(this.data.get("key") || "unset-key");
            this.inputTarget.value = val || "";
        }
    }
}



class $8419cb89c6e46f2b$export$2e2bcd8739ae039 extends (0, $5d5f3550be2e7e43$export$bd0bf19f25da8474) {
    // States of input forms:
    // Unvisited / visited
    // Empty / Valid / Invalid
    static get targets() {
        return [
            "input",
            "label"
        ];
    }
    setValid() {
        // TODO: migrate from DataMaps to Values
        this.data.set("state", "valid");
        // TODO: use new Stimulus Classes API
        // https://stimulus.hotwired.dev/reference/css-classes
        this.labelTarget.classList.remove("form-invalid");
        this.labelTarget.textContent = "";
    }
    setInvalid() {
        // TODO: migrate from DataMaps to Values
        this.data.set("state", "invalid");
        this.labelTarget.classList.add("form-invalid");
        const validationMessage = this.inputTarget.validationMessage;
        this.labelTarget.innerText = validationMessage;
    }
    validate() {
        if (!this.inputTarget.checkValidity() && this.inputTarget.value !== "") this.setInvalid();
        else this.setValid();
    }
}



// https://gist.github.com/mathewbyrne/1280286
function $24571cb002bfc19a$export$c383cdd2a518017a(text) {
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, ""); // Trim - from start of text
// .replace(/-+$/, '');            // Trim - from end of text
}


class $84c3cf63e9b82ff0$export$2e2bcd8739ae039 extends (0, $5d5f3550be2e7e43$export$bd0bf19f25da8474) {
    static get targets() {
        return [
            "source",
            "slug",
            "slugLabel"
        ];
    }
    sourceInput() {
        // Once the user has typed into the slug field, we don't
        // slugify the values anymore.
        // TODO: migrate from DataMaps to Values
        if (!this.data.has("slug-dirty")) {
            const slug = (0, $24571cb002bfc19a$export$c383cdd2a518017a)(this.sourceTarget.value);
            this.setValue(this.slugTarget, slug);
        }
    }
    slugInput(ev) {
        const focused = document.activeElement === this.slugTarget;
        const originalSlug = this.slugTarget.value;
        const slugified = (0, $24571cb002bfc19a$export$c383cdd2a518017a)(originalSlug);
        this.slugTarget.value = slugified;
        this.setSlugLabel(slugified);
        if (focused && this.slugTarget.selectionStart) {
            // If slugify hasn't changed the length of the slug then
            // the selectionStart will already be in the correct place
            // (it already moved when the input was made).
            // If the string length has changed, e.g. someone tried to type $,
            // or paste $a$, then we reset the selectionStart back to the position
            // it would have been if only legal letters were typed.
            const selectionStart = this.slugTarget.selectionStart;
            const cursorOffset = originalSlug.length - slugified.length;
            const newSelectionStart = selectionStart - cursorOffset;
            this.slugTarget.setSelectionRange(newSelectionStart, newSelectionStart);
        }
    }
    slugChange(ev) {
        // The change event is fired when there was a user actually typing in this field.
        // TODO: migrate from DataMaps to Values
        this.data.set("slug-dirty", "yes");
    }
    setValue(input, value) {
        input.value = value;
        // The second call here is because of Safari not hiding placeholder text:
        // http://stackoverflow.com/q/39624902/826486
        input.value = value;
        input.dispatchEvent(new Event("input", {
            bubbles: true
        }));
    }
    setSlugLabel(slug) {
        if (this.hasSlugLabelTarget) {
            if (slug === "") // TODO: migrate from DataMaps to Values
            this.slugLabelTarget.textContent = this.data.get("empty-label") || "";
            else this.slugLabelTarget.textContent = slug;
        }
    }
}



function $10273c39dbddd2ba$var$selectText(element) {
    const selection = window.getSelection();
    if (selection) {
        if (selection.type !== "Range") {
            const range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}
class $10273c39dbddd2ba$export$2e2bcd8739ae039 extends (0, $5d5f3550be2e7e43$export$bd0bf19f25da8474) {
    static get targets() {
        return [
            "text"
        ];
    }
    select() {
        $10273c39dbddd2ba$var$selectText(this.textTarget);
    }
}



class $3c55aa6f9d6569c0$export$2e2bcd8739ae039 extends (0, $5d5f3550be2e7e43$export$bd0bf19f25da8474) {
    static get targets() {
        return [
            "input"
        ];
    }
    connect() {
        if (window.hasOwnProperty("Intl") && Intl.DateTimeFormat) // https://danielcompton.net/2017/07/06/detect-user-timezone-javascript
        this.inputTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
}



class $b09d0a45db64dce4$export$2e2bcd8739ae039 extends (0, $5d5f3550be2e7e43$export$bd0bf19f25da8474) {
    static get targets() {
        return [
            "input"
        ];
    }
    initialize() {
        this.isStorageSupported = typeof Storage !== "undefined";
    }
    inputChanged() {
        if (this.isStorageSupported) {
            const inputValue = this.inputTarget.value;
            // TODO: migrate from DataMaps to Values
            sessionStorage.setItem(this.data.get("key") || "unset-key", inputValue);
        }
    }
}


let $e354e14dc11c52d8$var$commonSetup = ()=>{
    window.removeEventListener("load", $e354e14dc11c52d8$var$commonSetup, false); // remove listener, no longer needed
    const supportUnreadElement = document.getElementById("support-unread-count");
    if (window.hasOwnProperty("Intercom") && supportUnreadElement != null) Intercom("onUnreadCountChange", (unreadCount)=>{
        if (unreadCount > 0) supportUnreadElement.textContent = " (" + unreadCount + ")";
        else supportUnreadElement.textContent = "";
    });
};
window.addEventListener("load", $e354e14dc11c52d8$var$commonSetup, false);


function $8de0cd26672f9567$var$AddClass(obj, cName) {
    return obj && obj.classList.add(cName);
}
// ***Removes a particular class from an object, preserving other existing classes.
function $8de0cd26672f9567$var$KillClass(obj, cName) {
    return obj && obj.classList.remove(cName);
}
// ***Returns true if the object has the class assigned, false otherwise.
function $8de0cd26672f9567$var$HasClass(obj, cName) {
    return obj && obj.classList.contains(cName);
}
// *** Tabtastic -- see http://phrogz.net/JS/Tabstatic/index.html
window.addEventListener("load", ()=>{
    const tocTag = "ul";
    const tocClass = "tabset_tabs";
    const tabTag = "a";
    // let contentClass = "tabset_content";
    function FindEl(tagName, evt) {
        // Handle IE8 and lower which don't provide an Event
        // in callbacks. Can probably remove this at some point.
        if (!evt && window.event) evt = window.event;
        let el = evt.currentTarget || evt.srcElement;
        while(el && (!el.tagName || el.tagName.toLowerCase() !== tagName))el = el.parentNode;
        return el;
    }
    function SetTabActive(tab) {
        if (tab.tabTOC.activeTab) {
            if (tab.tabTOC.activeTab === tab) return;
            $8de0cd26672f9567$var$KillClass(tab.tabTOC.activeTab, "active");
            if (tab.tabTOC.activeTab.tabContent) $8de0cd26672f9567$var$KillClass(tab.tabTOC.activeTab.tabContent, "tabset_content_active");
            // if (tab.tabTOC.activeTab.tabContent) tab.tabTOC.activeTab.tabContent.style.display='';
            if (tab.tabTOC.activeTab.prevTab) $8de0cd26672f9567$var$KillClass(tab.tabTOC.activeTab.previousTab, "preActive");
            if (tab.tabTOC.activeTab.nextTab) $8de0cd26672f9567$var$KillClass(tab.tabTOC.activeTab.nextTab, "postActive");
        }
        $8de0cd26672f9567$var$AddClass(tab.tabTOC.activeTab = tab, "active");
        if (tab.tabContent) $8de0cd26672f9567$var$AddClass(tab.tabContent, "tabset_content_active");
        // if (tab.tabContent) tab.tabContent.style.display='block';
        if (tab.prevTab) $8de0cd26672f9567$var$AddClass(tab.prevTab, "preActive");
        if (tab.nextTab) $8de0cd26672f9567$var$AddClass(tab.nextTab, "postActive");
    }
    function SetTabFromAnchor(evt) {
        const scrollPosition = document.documentElement.scrollTop;
        const tab = FindEl("a", evt).semanticTab;
        SetTabActive(tab);
        // Prevent default to prevent the browser from scrolling to the anchor
        evt.preventDefault();
        document.documentElement.scrollTop = scrollPosition;
        // http://lea.verou.me/2011/05/change-url-hash-without-page-jump/
        const hash = "#" + tab.tabID;
        if (history.pushState) history.pushState(null, "", hash);
        else location.hash = hash;
    }
    function Init() {
        const everyTabThereIsById = {};
        const anchorMatch = /#([a-z][\w.:-]*)$/i;
        let match;
        const activeTabs = [];
        const tocs = document.getElementsByTagName(tocTag);
        for(let i = 0, len = tocs.length; i < len; i++){
            const toc = tocs[i];
            if (!$8de0cd26672f9567$var$HasClass(toc, tocClass)) continue;
            let lastTab;
            const tabs = toc.getElementsByTagName(tabTag);
            for(let j = 0, len2 = tabs.length; j < len2; j++){
                const tab = tabs[j];
                // tslint:disable-next-line:no-conditional-assignment
                if (!tab.href || !(match = anchorMatch.exec(tab.href))) continue;
                if (lastTab) {
                    tab.prevTab = lastTab;
                    lastTab.nextTab = tab;
                }
                tab.tabTOC = toc;
                everyTabThereIsById[tab.tabID = match[1]] = tab;
                const tabElement = document.getElementById(tab.tabID);
                if (tabElement) tab.tabContent = tabElement;
                if ($8de0cd26672f9567$var$HasClass(tab, "active")) activeTabs[activeTabs.length] = tab;
                lastTab = tab;
            }
            $8de0cd26672f9567$var$AddClass(toc.getElementsByTagName("li")[0], "firstchild");
        }
        for(let i = 0, len = activeTabs.length; i < len; i++)SetTabActive(activeTabs[i]);
        let a = null;
        for(let i = 0, len = document.links.length; i < len; i++){
            a = document.links[i];
            // tslint:disable-next-line:no-conditional-assignment
            if (!(match = anchorMatch.exec(a.href))) continue;
            // tslint:disable-next-line:no-conditional-assignment
            if (a.semanticTab = everyTabThereIsById[match[1]]) a.addEventListener("click", SetTabFromAnchor, false);
        }
        if (// tslint:disable-next-line:no-conditional-assignment
        (match = anchorMatch.exec(location.href)) && // tslint:disable-next-line:no-conditional-assignment
        (a = everyTabThereIsById[match[1]])) SetTabActive(a);
    }
    Init();
}, false);


const $2a15930ebed49689$var$application = (0, $12bdc35e7457d4b6$export$16975c34e60e1e61).start();
$2a15930ebed49689$var$application.handleError = (error, message, detail)=>{
    // tslint:disable-next-line:no-console
    console.error(message, detail);
    Raven.captureException(error);
};
$2a15930ebed49689$var$application.register("from-sessionstore", (0, $4dd888bafdf04186$export$2e2bcd8739ae039));
$2a15930ebed49689$var$application.register("input-validation", (0, $8419cb89c6e46f2b$export$2e2bcd8739ae039));
$2a15930ebed49689$var$application.register("slugify", (0, $84c3cf63e9b82ff0$export$2e2bcd8739ae039));
$2a15930ebed49689$var$application.register("text-select", (0, $10273c39dbddd2ba$export$2e2bcd8739ae039));
$2a15930ebed49689$var$application.register("timezone-detector", (0, $3c55aa6f9d6569c0$export$2e2bcd8739ae039));
$2a15930ebed49689$var$application.register("to-sessionstore", (0, $b09d0a45db64dce4$export$2e2bcd8739ae039));

})();
//# sourceMappingURL=index.4414894d.js.map
